

























































import { Component, Watch } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import { treatValue } from '@/utils/moneyTreatments';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import eventBus from '@/utils/eventBus';
import DateUtils from '@/utils/DateUtils';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import AdminService from '@/api/AdminService';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { FilledButton } from '@/components/molecules';
import Row from '@/components/atoms/Grid/Row.vue';

@Component({
  components: {
    Table,
    RowsTable,
    TextInput,
    ContextMenu,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    FilledButton,
    Row
  }
})
export default class KeywordsList extends BasePagination {
  constructor() {
    super();
  }
  service = new AdminService();
  keywords: List = new List([], []);
  keyOrder: string[] = [];

  @Watch('getFlags')
  onChange() {
    this.assignHeader();
  }

  mounted() {
    this.assignHeader();
  }

  reloadList(clearList?: boolean, refreshCurrent?: boolean, query?: string) {
    if (clearList) {
      this.resetPagination();
      this.keywords.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;

    this.$showLoaderWithLocker();
    this.refreshing = true;

    this.service
      .getKeywords({
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pagination: this.pagination,
        filters: this.query.replace('search=', 'keywordName=')
      })
      .then((response: any) => {
        const { items, links } = response.data;

        if (refreshCurrent) {
          this.resetPagination();
          this.pagination = links.next;
          if (!links.next) this.maxItems = true;
          this.keywords.list = this.addRowsKeywords(items);
          this.isLoading = false;
        } else {
          this.keywords.list = this.keywords.list.concat(
            this.addRowsKeywords(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = links.next;
        }
      })
      .finally(() => {
        this.$hideLoader();
        this.isLoading = false;
        this.refreshing = false;
      });
  }

  assignHeader() {
    const { keyOrder } = this;

    keyOrder.push('createdAt');
    keyOrder.push('name');
    keyOrder.push('qtdBusinessLinked');
    keyOrder.push('slot:options');

    const header = [];
    header.push(new HeaderList(`Keyword`, 'keyword.name'));
    header.push(new HeaderList(`Created at`, 'keyword.createdAt', '12px'));
    header.push(new HeaderList(`Qtd Businesses linked`, 'businessAssigned'));
    header.push(new HeaderList('', 'none', '12px'));
    this.keywords.header = header;
  }

  detail(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'adminKeywordDetails',
      data: event
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  addRowsKeywords(list: any[]): any[] {
    let rows: any[] = [];
    list.forEach((row: any) => {
      rows.push({
        ...row.keyword,
        qtdBusinessLinked: row.businessAssigned,
        createdAt: DateUtils.formatISODate(row.keyword.createdAt)
      });
    });
    return rows;
  }

  created() {
    eventBus.$on('reloadKeywords', this.reloadList);
  }

  beforeDestroy() {
    eventBus.$off('reloadKeywords', this.reloadList);
  }
}
